import { useEffect } from 'react';

import type { NwtTrackingProps, OmitFromUnion } from './use-jobs-nwt-tracking';
import { useJobsNwtTracking } from './use-jobs-nwt-tracking';

type UsePageTrackingArgs = {
  nwtOptions?: OmitFromUnion<NwtTrackingProps, 'eventSchema' | 'event'> & {
    eventSchema?: 'aicomponent';
  };
  repeatTracking?: boolean;
};

export const usePageTracking = ({ nwtOptions }: UsePageTrackingArgs): void => {
  const trackNwt = useJobsNwtTracking();

  useEffect(() => {
    if (nwtOptions?.page) {
      trackNwt({ eventSchema: 'basic', event: 'viewed_screen', ...nwtOptions });
    }
    // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
  }, [trackNwt]);
};
